export interface Company {
  id: string;
  name: string;
  status: CompanyStatus;
  subscriptionPlan: SubscriptionPlanName | null;
  numberOfProjects: string;
  companyType: string;
  companyAvatar: string;
  activationDate: null | Date;
}

export interface BasicInfo {
  id: number;
  companyName: Company['name'];
  companyType: {
    id: number;
    type: null | string;
  };
  taxID: string;
  companySize: {
    id: number;
    size: null | string;
  };
  companyStatus: {
    id: number;
    status: Company['status'];
  };
  numberOfProjects: Company['numberOfProjects'];
  countryList: {
    name: string;
  }[];
  companyLogoFileName: string;
  companyLogoFilePath: string;
  companyLogoSize: string;
  companyLogoThumbnailFileName: string;
  companyLogoThumbnailFilePath: string;
  companyLogoThumbnailSize: string;
  commercialRecordDocumentFileName: string;
  commercialRecordDocumentFilePath: string;
  commercialRecordDocumentSize: string;
  taxCardDocumentFileName: string;
  taxCardDocumentFilePath: string;
  taxCardDocumentSize: string;
  isDeleted: boolean;
  createdAt: Date;
  modifiedAt: Date;
  activationDate: Company['activationDate'];
}

export enum CompanyStatus {
  'ACTIVE' = 'ACTIVE',
  'INACTIVE' = 'INACTIVE',
  'PENDING' = 'PENDING',
}

export enum SubscriptionPlanName {
  'Starter' = 'Starter',
  'Golden' = 'Golden',
  'Platinum' = 'Platinum',
}

export interface ContactInfo {
  id: number;
  companyBasicInfo: BasicInfo;
  countryCode: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  email: string;
  jobTitle: string;
}

export interface SubscriptionPlan {
  id: number;
  companyBasicInfo: BasicInfo;
  subscriptionPlan: {
    id: number;
    planName: Company['subscriptionPlan'];
  };
}

export interface ChangedStatus {
  page: null;
  size: null;
  criteriaFilter: null;
  companyId: number;
  statusId: number;
}

export interface PaginatedCompany {
  page: number;
  status?: string;
  name?: string;
  subscriptionPlan?: string;
}
